import Stack from 'atoms/Layout/Stack/Stack';
import styled, { css } from 'styled-components';
import { mediaQuery } from 'styles/helper';

export const ActionsContainer = styled(Stack)`
  ${mediaQuery(
    'sm',
    css`
      width: 100%;
    `
  )}
`;
